import { ReactComponent as PlayEdLogoSVG } from "assets/playEdLogo.svg";
import { FC } from "react";
import styled from "styled-components";

export const PlayEdLogo: FC = () => {
  const handleClick = () => {
    window.parent.postMessage(
      { type: "GO_TO_HOME" },
      "*", // or parent origin for security
    );
  };
  return (
    <Logo onClick={() => handleClick()}>
      <PlayEdLogoSVG style={{ width: 200 }} />
    </Logo>
  );
};

const Logo = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 170px;
  margin-top: 5px;
  cursor: pointer;
  box-shadow: none;
`;
